<template>
  <section v-if="filteredReviews.length" class="page-content">
    <h2 class="text-xl lg:text-title font-bold mb-8">{{ title }}</h2>

    <section v-for="review in filteredReviews" :key="review.id" class="review mb-12">
      <p class="my-6">
        <heroicon class="inline mr-2" v-for="star in review.stars" :key="star" stroke="#FFB800" fill="#FFB800" stroke-width="0" name="star"></heroicon>
      </p>
      <h3 class="font-bold text-lg my-6">{{ review.name }}</h3>

      <div class="text-lg" v-html="review.body"></div>

    </section>

    <p>
      <router-link class="text-yellow font-bold text-lg" tag="a" :to="{ name: 'Reviews' }">Leggi tutte le recensioni</router-link>
    </p>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: "LastCatReviews",
    props: {
      cat: {
        type: String,
        default: 'All',
      },
      limit: {
        type: Number,
        default: 2,
      },
      title: {
        type: String,
        default: 'Fidati di chi si è fidato.'
      }
    },
    computed: {
      ...mapGetters({
        reviews: 'reviews'
      }),
      filteredReviews() {
        if( this.cat && (this.limit && this.limit > 0 ) ) {
          const limit = Math.round(this.limit);
          return this.reviews.filter((el) => {return el.cats.includes(this.cat)}).sort(() => Math.random() - Math.random()).slice(0, this.limit)
          // this.$bind('reviews', db.collection('reviews').where("cats", "array-contains", this.cat).limit(limit) );
        } else {
          return this.reviews;
        }
      }
    },
  }
</script>

<style scoped>

</style>